import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-public-page-banner',
    templateUrl: './public-page-banner.component.html',
    styleUrls: ['./public-page-banner.component.scss'],
    standalone: false
})
export class PublicPageBannerComponent implements OnInit {
  selected: 'Home' | 'CPOApprovedCourses' | 'EligibilityChecker' | 'ApprovedTrainingProviders' = 'Home';
  currentLang: string;
  pagepath: string = '';
  menuOpen: boolean = false;

  constructor(public translateService: TranslateService, public router: Router, public route: ActivatedRoute) {
    this.currentLang = translateService.currentLang;
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      let url = this.router.url.toLowerCase();
      this.pagepath = '';
      if (url.endsWith('/safety-and-prevention/cpo-approved-courses')) this.selected = 'CPOApprovedCourses';
      else if (url.endsWith('/safety-and-prevention/eligibility-checker')) this.selected = 'EligibilityChecker';
      else if (url.endsWith('/safety-and-prevention/approved-training-providers')) this.selected = 'ApprovedTrainingProviders';
      else {
        this.selected = 'Home';
        if (url.endsWith('/safety-and-prevention/training-providers')) this.pagepath = 'TrainingProviders';
        else if (url.endsWith('/safety-and-prevention/learners')) this.pagepath = 'Learners';
        else if (url.endsWith('/safety-and-prevention/employers')) this.pagepath = 'Employers';
        else if (url.indexOf('/safety-and-prevention/faqs')>=0) this.pagepath = 'FAQs';
        else this.pagepath = '';
      }
    });
  }
   
  goToLogin() {
    //set sessionStorage var to mark that we want to login
    sessionStorage.setItem('reload', 'true')
    const currentTime = new Date().toISOString()
   //this.router.navigate(['../training-provider/register-as-training-provider'], { queryParams: { refresh: `time_${currentTime}` }, relativeTo: this.route });
    this.router.navigate(['../registration/registrant'], { queryParams: { refresh: `time_${currentTime}` }, relativeTo: this.route } ).then(()=>{ window.location.reload();});
  }

  getUrl(url: string) { return this.currentLang == 'en' ? url : '/fr' + url; }
}
